
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tracking-order",
      function () {
        return require("private-next-pages/tracking-order/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tracking-order"])
      });
    }
  